import { createFileRoute } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";

export const Route = createFileRoute("/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy | Phoenix Plumbing Co." },
      { name: "description", content: "Privacy Policy for Phoenix Plumbing Co. Learn how we collect, use, store, and protect customer information when you request plumbing service in Phoenix, AZ." },
      { property: "og:title", content: "Privacy Policy | Phoenix Plumbing Co." },
      { property: "og:description", content: "Privacy Policy for Phoenix Plumbing Co. Learn how we collect, use, store, and protect customer information when you request plumbing service in Phoenix, AZ." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/privacy-policy" },
      { name: "twitter:title", content: "Privacy Policy | Phoenix Plumbing Co." },
      { name: "twitter:description", content: "Privacy Policy for Phoenix Plumbing Co. Learn how we collect, use, store, and protect customer information when you request plumbing service in Phoenix, AZ." },
      { name: "robots", content: "noindex,follow" },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/privacy-policy" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="bg-secondary text-secondary-foreground">
        <div className="mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Privacy Policy</h1>
          <p className="mt-4 text-secondary-foreground/85 text-lg">How Phoenix Plumbing Co. collects, uses, and protects your information.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <article className="mx-auto max-w-3xl px-4 py-12 prose prose-lg">
        <p>
          Phoenix Plumbing Co. respects your privacy. This page explains what information we
          collect, how we use it, and how to reach us with questions.
        </p>

        <h2>Information We Collect</h2>
        <p>
          We collect information you provide through our quote form, phone calls, and email,
          including your name, phone number, email address, service address, and details about
          your plumbing issue. We also collect standard analytics data through cookies to improve
          our site.
        </p>

        <h2>How We Use Your Information</h2>
        <p>
          We use your information to respond to service requests, schedule appointments, send
          appointment updates, follow up after service, and improve our website.
        </p>

        <h2>Data Sharing</h2>
        <p>
          We do not sell personal information. We share information only with limited service
          providers acting on our behalf (for example, our scheduling and dispatch tools), and
          only as needed to deliver the service you requested.
        </p>

        <h2>SMS Consent</h2>
        <p>
          If you provide a phone number or opt in to text messages, your consent is used only to
          communicate with you about your inquiry, appointment, or service. Phone numbers and SMS
          opt-in information are not sold or shared with third parties for their marketing.
        </p>

        <h2>Text Message Opt-Out</h2>
        <p>
          You can opt out of text messages at any time by replying STOP. Reply HELP for help, or
          call us at 602-834-1208.
        </p>

        <h2>Cookies & Analytics</h2>
        <p>
          We use standard analytics cookies to understand how visitors use our site. You can
          control or disable cookies through your browser settings.
        </p>

        <h2>Contact Us About Your Privacy</h2>
        <p>
          Phoenix Plumbing Co.<br />
          Phone: 602-834-1208<br />
          Website: https://www.phoenixplumbing.co/
        </p>
      </article>
      <CTABand />
    </>
  );
}
